
import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { LinkGrid } from 'components/Docs/LinkGrid'
import Link from 'components/Link'
import { prepareData } from 'utils/googleData'

  export function DocsHero(props) {
    const { enable, title, subtitle, text, cta, direction, style, lottie, gatsbyImage, items,gatsbyImageSrc } = prepareData({
        props,
    })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
      <div className="mt-8 mb-8 space-y-16 lg:mt-0 lg:space-y-20">
    <section className="border-b border-dashed border-gray-accent-light pb-8 dark:border-gray-accent-dark">
      <div className="z-20 w-full">
       { gatsbyImage && <GatsbyImage
          objectFit="contain"
          image={gatsbyImage}
          alt={title}
          width={400}
          placeholder="blurred"
          className="mb-8 w-full sm:float-right sm:ml-8 sm:-mt-8 sm:w-[400px]"
        /> }
        <h1 className="mb-2 whitespace-nowrap text-3xl font-bold md:text-4xl lg:text-5xl">{title}</h1>
        <h5 className="leading-tighttext-lg pb-8 text-lg font-semibold text-primary/60 text-gray dark:text-primary-dark/75">
          {subtitle} <Link to={cta?.url} className="font-semibold">{cta?.label}</Link>
        </h5>
      </div>
      {text ? (
          <section className="clear-both my-12">
            <h3 className="mb-6 mt-0">{text}</h3>
            <LinkGrid links={items} />
          </section>
        ) : (
          <LinkGrid links={items} />
        )}
    </section>
    </div>
  )
}
export default DocsHero
